var map = {
	"./af-NA/currencies.json": [
		"./node_modules/cldr-data/main/af-NA/currencies.json",
		39
	],
	"./af/currencies.json": [
		"./node_modules/cldr-data/main/af/currencies.json",
		44
	],
	"./am/currencies.json": [
		"./node_modules/cldr-data/main/am/currencies.json",
		49
	],
	"./ar-AE/currencies.json": [
		"./node_modules/cldr-data/main/ar-AE/currencies.json",
		54
	],
	"./ar-BH/currencies.json": [
		"./node_modules/cldr-data/main/ar-BH/currencies.json",
		59
	],
	"./ar-DJ/currencies.json": [
		"./node_modules/cldr-data/main/ar-DJ/currencies.json",
		64
	],
	"./ar-DZ/currencies.json": [
		"./node_modules/cldr-data/main/ar-DZ/currencies.json",
		69
	],
	"./ar-EG/currencies.json": [
		"./node_modules/cldr-data/main/ar-EG/currencies.json",
		74
	],
	"./ar-EH/currencies.json": [
		"./node_modules/cldr-data/main/ar-EH/currencies.json",
		79
	],
	"./ar-ER/currencies.json": [
		"./node_modules/cldr-data/main/ar-ER/currencies.json",
		84
	],
	"./ar-IL/currencies.json": [
		"./node_modules/cldr-data/main/ar-IL/currencies.json",
		89
	],
	"./ar-IQ/currencies.json": [
		"./node_modules/cldr-data/main/ar-IQ/currencies.json",
		94
	],
	"./ar-JO/currencies.json": [
		"./node_modules/cldr-data/main/ar-JO/currencies.json",
		99
	],
	"./ar-KM/currencies.json": [
		"./node_modules/cldr-data/main/ar-KM/currencies.json",
		104
	],
	"./ar-KW/currencies.json": [
		"./node_modules/cldr-data/main/ar-KW/currencies.json",
		109
	],
	"./ar-LB/currencies.json": [
		"./node_modules/cldr-data/main/ar-LB/currencies.json",
		114
	],
	"./ar-LY/currencies.json": [
		"./node_modules/cldr-data/main/ar-LY/currencies.json",
		119
	],
	"./ar-MA/currencies.json": [
		"./node_modules/cldr-data/main/ar-MA/currencies.json",
		124
	],
	"./ar-MR/currencies.json": [
		"./node_modules/cldr-data/main/ar-MR/currencies.json",
		129
	],
	"./ar-OM/currencies.json": [
		"./node_modules/cldr-data/main/ar-OM/currencies.json",
		134
	],
	"./ar-PS/currencies.json": [
		"./node_modules/cldr-data/main/ar-PS/currencies.json",
		139
	],
	"./ar-QA/currencies.json": [
		"./node_modules/cldr-data/main/ar-QA/currencies.json",
		144
	],
	"./ar-SA/currencies.json": [
		"./node_modules/cldr-data/main/ar-SA/currencies.json",
		149
	],
	"./ar-SD/currencies.json": [
		"./node_modules/cldr-data/main/ar-SD/currencies.json",
		154
	],
	"./ar-SO/currencies.json": [
		"./node_modules/cldr-data/main/ar-SO/currencies.json",
		159
	],
	"./ar-SS/currencies.json": [
		"./node_modules/cldr-data/main/ar-SS/currencies.json",
		164
	],
	"./ar-SY/currencies.json": [
		"./node_modules/cldr-data/main/ar-SY/currencies.json",
		169
	],
	"./ar-TD/currencies.json": [
		"./node_modules/cldr-data/main/ar-TD/currencies.json",
		174
	],
	"./ar-TN/currencies.json": [
		"./node_modules/cldr-data/main/ar-TN/currencies.json",
		179
	],
	"./ar-YE/currencies.json": [
		"./node_modules/cldr-data/main/ar-YE/currencies.json",
		184
	],
	"./ar/currencies.json": [
		"./node_modules/cldr-data/main/ar/currencies.json",
		189
	],
	"./as/currencies.json": [
		"./node_modules/cldr-data/main/as/currencies.json",
		194
	],
	"./az-Latn/currencies.json": [
		"./node_modules/cldr-data/main/az-Latn/currencies.json",
		199
	],
	"./az/currencies.json": [
		"./node_modules/cldr-data/main/az/currencies.json",
		204
	],
	"./be/currencies.json": [
		"./node_modules/cldr-data/main/be/currencies.json",
		209
	],
	"./bg/currencies.json": [
		"./node_modules/cldr-data/main/bg/currencies.json",
		214
	],
	"./bn-IN/currencies.json": [
		"./node_modules/cldr-data/main/bn-IN/currencies.json",
		219
	],
	"./bn/currencies.json": [
		"./node_modules/cldr-data/main/bn/currencies.json",
		224
	],
	"./bs-Latn/currencies.json": [
		"./node_modules/cldr-data/main/bs-Latn/currencies.json",
		229
	],
	"./bs/currencies.json": [
		"./node_modules/cldr-data/main/bs/currencies.json",
		234
	],
	"./ca-AD/currencies.json": [
		"./node_modules/cldr-data/main/ca-AD/currencies.json",
		239
	],
	"./ca-ES-VALENCIA/currencies.json": [
		"./node_modules/cldr-data/main/ca-ES-VALENCIA/currencies.json",
		244
	],
	"./ca-FR/currencies.json": [
		"./node_modules/cldr-data/main/ca-FR/currencies.json",
		249
	],
	"./ca-IT/currencies.json": [
		"./node_modules/cldr-data/main/ca-IT/currencies.json",
		254
	],
	"./ca/currencies.json": [
		"./node_modules/cldr-data/main/ca/currencies.json",
		259
	],
	"./cs/currencies.json": [
		"./node_modules/cldr-data/main/cs/currencies.json",
		264
	],
	"./cy/currencies.json": [
		"./node_modules/cldr-data/main/cy/currencies.json",
		269
	],
	"./da-GL/currencies.json": [
		"./node_modules/cldr-data/main/da-GL/currencies.json",
		274
	],
	"./da/currencies.json": [
		"./node_modules/cldr-data/main/da/currencies.json",
		279
	],
	"./de-AT/currencies.json": [
		"./node_modules/cldr-data/main/de-AT/currencies.json",
		284
	],
	"./de-BE/currencies.json": [
		"./node_modules/cldr-data/main/de-BE/currencies.json",
		289
	],
	"./de-CH/currencies.json": [
		"./node_modules/cldr-data/main/de-CH/currencies.json",
		294
	],
	"./de-IT/currencies.json": [
		"./node_modules/cldr-data/main/de-IT/currencies.json",
		299
	],
	"./de-LI/currencies.json": [
		"./node_modules/cldr-data/main/de-LI/currencies.json",
		304
	],
	"./de-LU/currencies.json": [
		"./node_modules/cldr-data/main/de-LU/currencies.json",
		309
	],
	"./de/currencies.json": [
		"./node_modules/cldr-data/main/de/currencies.json",
		314
	],
	"./el-CY/currencies.json": [
		"./node_modules/cldr-data/main/el-CY/currencies.json",
		319
	],
	"./el/currencies.json": [
		"./node_modules/cldr-data/main/el/currencies.json",
		324
	],
	"./en-001/currencies.json": [
		"./node_modules/cldr-data/main/en-001/currencies.json",
		329
	],
	"./en-150/currencies.json": [
		"./node_modules/cldr-data/main/en-150/currencies.json",
		334
	],
	"./en-AE/currencies.json": [
		"./node_modules/cldr-data/main/en-AE/currencies.json",
		339
	],
	"./en-AG/currencies.json": [
		"./node_modules/cldr-data/main/en-AG/currencies.json",
		344
	],
	"./en-AI/currencies.json": [
		"./node_modules/cldr-data/main/en-AI/currencies.json",
		349
	],
	"./en-AS/currencies.json": [
		"./node_modules/cldr-data/main/en-AS/currencies.json",
		354
	],
	"./en-AT/currencies.json": [
		"./node_modules/cldr-data/main/en-AT/currencies.json",
		359
	],
	"./en-AU/currencies.json": [
		"./node_modules/cldr-data/main/en-AU/currencies.json",
		364
	],
	"./en-BB/currencies.json": [
		"./node_modules/cldr-data/main/en-BB/currencies.json",
		369
	],
	"./en-BE/currencies.json": [
		"./node_modules/cldr-data/main/en-BE/currencies.json",
		374
	],
	"./en-BI/currencies.json": [
		"./node_modules/cldr-data/main/en-BI/currencies.json",
		379
	],
	"./en-BM/currencies.json": [
		"./node_modules/cldr-data/main/en-BM/currencies.json",
		384
	],
	"./en-BS/currencies.json": [
		"./node_modules/cldr-data/main/en-BS/currencies.json",
		389
	],
	"./en-BW/currencies.json": [
		"./node_modules/cldr-data/main/en-BW/currencies.json",
		394
	],
	"./en-BZ/currencies.json": [
		"./node_modules/cldr-data/main/en-BZ/currencies.json",
		399
	],
	"./en-CA/currencies.json": [
		"./node_modules/cldr-data/main/en-CA/currencies.json",
		404
	],
	"./en-CC/currencies.json": [
		"./node_modules/cldr-data/main/en-CC/currencies.json",
		409
	],
	"./en-CH/currencies.json": [
		"./node_modules/cldr-data/main/en-CH/currencies.json",
		414
	],
	"./en-CK/currencies.json": [
		"./node_modules/cldr-data/main/en-CK/currencies.json",
		419
	],
	"./en-CM/currencies.json": [
		"./node_modules/cldr-data/main/en-CM/currencies.json",
		424
	],
	"./en-CX/currencies.json": [
		"./node_modules/cldr-data/main/en-CX/currencies.json",
		429
	],
	"./en-CY/currencies.json": [
		"./node_modules/cldr-data/main/en-CY/currencies.json",
		434
	],
	"./en-DE/currencies.json": [
		"./node_modules/cldr-data/main/en-DE/currencies.json",
		439
	],
	"./en-DG/currencies.json": [
		"./node_modules/cldr-data/main/en-DG/currencies.json",
		444
	],
	"./en-DK/currencies.json": [
		"./node_modules/cldr-data/main/en-DK/currencies.json",
		449
	],
	"./en-DM/currencies.json": [
		"./node_modules/cldr-data/main/en-DM/currencies.json",
		454
	],
	"./en-ER/currencies.json": [
		"./node_modules/cldr-data/main/en-ER/currencies.json",
		459
	],
	"./en-FI/currencies.json": [
		"./node_modules/cldr-data/main/en-FI/currencies.json",
		464
	],
	"./en-FJ/currencies.json": [
		"./node_modules/cldr-data/main/en-FJ/currencies.json",
		469
	],
	"./en-FK/currencies.json": [
		"./node_modules/cldr-data/main/en-FK/currencies.json",
		474
	],
	"./en-FM/currencies.json": [
		"./node_modules/cldr-data/main/en-FM/currencies.json",
		479
	],
	"./en-GB/currencies.json": [
		"./node_modules/cldr-data/main/en-GB/currencies.json",
		484
	],
	"./en-GD/currencies.json": [
		"./node_modules/cldr-data/main/en-GD/currencies.json",
		489
	],
	"./en-GG/currencies.json": [
		"./node_modules/cldr-data/main/en-GG/currencies.json",
		494
	],
	"./en-GH/currencies.json": [
		"./node_modules/cldr-data/main/en-GH/currencies.json",
		499
	],
	"./en-GI/currencies.json": [
		"./node_modules/cldr-data/main/en-GI/currencies.json",
		504
	],
	"./en-GM/currencies.json": [
		"./node_modules/cldr-data/main/en-GM/currencies.json",
		509
	],
	"./en-GU/currencies.json": [
		"./node_modules/cldr-data/main/en-GU/currencies.json",
		514
	],
	"./en-GY/currencies.json": [
		"./node_modules/cldr-data/main/en-GY/currencies.json",
		519
	],
	"./en-HK/currencies.json": [
		"./node_modules/cldr-data/main/en-HK/currencies.json",
		524
	],
	"./en-IE/currencies.json": [
		"./node_modules/cldr-data/main/en-IE/currencies.json",
		529
	],
	"./en-IL/currencies.json": [
		"./node_modules/cldr-data/main/en-IL/currencies.json",
		534
	],
	"./en-IM/currencies.json": [
		"./node_modules/cldr-data/main/en-IM/currencies.json",
		539
	],
	"./en-IN/currencies.json": [
		"./node_modules/cldr-data/main/en-IN/currencies.json",
		544
	],
	"./en-IO/currencies.json": [
		"./node_modules/cldr-data/main/en-IO/currencies.json",
		549
	],
	"./en-JE/currencies.json": [
		"./node_modules/cldr-data/main/en-JE/currencies.json",
		554
	],
	"./en-JM/currencies.json": [
		"./node_modules/cldr-data/main/en-JM/currencies.json",
		559
	],
	"./en-KE/currencies.json": [
		"./node_modules/cldr-data/main/en-KE/currencies.json",
		564
	],
	"./en-KI/currencies.json": [
		"./node_modules/cldr-data/main/en-KI/currencies.json",
		569
	],
	"./en-KN/currencies.json": [
		"./node_modules/cldr-data/main/en-KN/currencies.json",
		574
	],
	"./en-KY/currencies.json": [
		"./node_modules/cldr-data/main/en-KY/currencies.json",
		579
	],
	"./en-LC/currencies.json": [
		"./node_modules/cldr-data/main/en-LC/currencies.json",
		584
	],
	"./en-LR/currencies.json": [
		"./node_modules/cldr-data/main/en-LR/currencies.json",
		589
	],
	"./en-LS/currencies.json": [
		"./node_modules/cldr-data/main/en-LS/currencies.json",
		594
	],
	"./en-MG/currencies.json": [
		"./node_modules/cldr-data/main/en-MG/currencies.json",
		599
	],
	"./en-MH/currencies.json": [
		"./node_modules/cldr-data/main/en-MH/currencies.json",
		604
	],
	"./en-MO/currencies.json": [
		"./node_modules/cldr-data/main/en-MO/currencies.json",
		609
	],
	"./en-MP/currencies.json": [
		"./node_modules/cldr-data/main/en-MP/currencies.json",
		614
	],
	"./en-MS/currencies.json": [
		"./node_modules/cldr-data/main/en-MS/currencies.json",
		619
	],
	"./en-MT/currencies.json": [
		"./node_modules/cldr-data/main/en-MT/currencies.json",
		624
	],
	"./en-MU/currencies.json": [
		"./node_modules/cldr-data/main/en-MU/currencies.json",
		629
	],
	"./en-MW/currencies.json": [
		"./node_modules/cldr-data/main/en-MW/currencies.json",
		634
	],
	"./en-MY/currencies.json": [
		"./node_modules/cldr-data/main/en-MY/currencies.json",
		639
	],
	"./en-NA/currencies.json": [
		"./node_modules/cldr-data/main/en-NA/currencies.json",
		644
	],
	"./en-NF/currencies.json": [
		"./node_modules/cldr-data/main/en-NF/currencies.json",
		649
	],
	"./en-NG/currencies.json": [
		"./node_modules/cldr-data/main/en-NG/currencies.json",
		654
	],
	"./en-NL/currencies.json": [
		"./node_modules/cldr-data/main/en-NL/currencies.json",
		659
	],
	"./en-NR/currencies.json": [
		"./node_modules/cldr-data/main/en-NR/currencies.json",
		664
	],
	"./en-NU/currencies.json": [
		"./node_modules/cldr-data/main/en-NU/currencies.json",
		669
	],
	"./en-NZ/currencies.json": [
		"./node_modules/cldr-data/main/en-NZ/currencies.json",
		674
	],
	"./en-PG/currencies.json": [
		"./node_modules/cldr-data/main/en-PG/currencies.json",
		679
	],
	"./en-PH/currencies.json": [
		"./node_modules/cldr-data/main/en-PH/currencies.json",
		684
	],
	"./en-PK/currencies.json": [
		"./node_modules/cldr-data/main/en-PK/currencies.json",
		689
	],
	"./en-PN/currencies.json": [
		"./node_modules/cldr-data/main/en-PN/currencies.json",
		694
	],
	"./en-PR/currencies.json": [
		"./node_modules/cldr-data/main/en-PR/currencies.json",
		699
	],
	"./en-PW/currencies.json": [
		"./node_modules/cldr-data/main/en-PW/currencies.json",
		704
	],
	"./en-RW/currencies.json": [
		"./node_modules/cldr-data/main/en-RW/currencies.json",
		709
	],
	"./en-SB/currencies.json": [
		"./node_modules/cldr-data/main/en-SB/currencies.json",
		714
	],
	"./en-SC/currencies.json": [
		"./node_modules/cldr-data/main/en-SC/currencies.json",
		719
	],
	"./en-SD/currencies.json": [
		"./node_modules/cldr-data/main/en-SD/currencies.json",
		724
	],
	"./en-SE/currencies.json": [
		"./node_modules/cldr-data/main/en-SE/currencies.json",
		729
	],
	"./en-SG/currencies.json": [
		"./node_modules/cldr-data/main/en-SG/currencies.json",
		734
	],
	"./en-SH/currencies.json": [
		"./node_modules/cldr-data/main/en-SH/currencies.json",
		739
	],
	"./en-SI/currencies.json": [
		"./node_modules/cldr-data/main/en-SI/currencies.json",
		744
	],
	"./en-SL/currencies.json": [
		"./node_modules/cldr-data/main/en-SL/currencies.json",
		749
	],
	"./en-SS/currencies.json": [
		"./node_modules/cldr-data/main/en-SS/currencies.json",
		754
	],
	"./en-SX/currencies.json": [
		"./node_modules/cldr-data/main/en-SX/currencies.json",
		759
	],
	"./en-SZ/currencies.json": [
		"./node_modules/cldr-data/main/en-SZ/currencies.json",
		764
	],
	"./en-TC/currencies.json": [
		"./node_modules/cldr-data/main/en-TC/currencies.json",
		769
	],
	"./en-TK/currencies.json": [
		"./node_modules/cldr-data/main/en-TK/currencies.json",
		774
	],
	"./en-TO/currencies.json": [
		"./node_modules/cldr-data/main/en-TO/currencies.json",
		779
	],
	"./en-TT/currencies.json": [
		"./node_modules/cldr-data/main/en-TT/currencies.json",
		784
	],
	"./en-TV/currencies.json": [
		"./node_modules/cldr-data/main/en-TV/currencies.json",
		789
	],
	"./en-TZ/currencies.json": [
		"./node_modules/cldr-data/main/en-TZ/currencies.json",
		794
	],
	"./en-UG/currencies.json": [
		"./node_modules/cldr-data/main/en-UG/currencies.json",
		799
	],
	"./en-UM/currencies.json": [
		"./node_modules/cldr-data/main/en-UM/currencies.json",
		804
	],
	"./en-US-POSIX/currencies.json": [
		"./node_modules/cldr-data/main/en-US-POSIX/currencies.json",
		809
	],
	"./en-VC/currencies.json": [
		"./node_modules/cldr-data/main/en-VC/currencies.json",
		814
	],
	"./en-VG/currencies.json": [
		"./node_modules/cldr-data/main/en-VG/currencies.json",
		819
	],
	"./en-VI/currencies.json": [
		"./node_modules/cldr-data/main/en-VI/currencies.json",
		824
	],
	"./en-VU/currencies.json": [
		"./node_modules/cldr-data/main/en-VU/currencies.json",
		829
	],
	"./en-WS/currencies.json": [
		"./node_modules/cldr-data/main/en-WS/currencies.json",
		834
	],
	"./en-ZA/currencies.json": [
		"./node_modules/cldr-data/main/en-ZA/currencies.json",
		839
	],
	"./en-ZM/currencies.json": [
		"./node_modules/cldr-data/main/en-ZM/currencies.json",
		844
	],
	"./en-ZW/currencies.json": [
		"./node_modules/cldr-data/main/en-ZW/currencies.json",
		849
	],
	"./en/currencies.json": [
		"./node_modules/cldr-data/main/en/currencies.json",
		854
	],
	"./es-419/currencies.json": [
		"./node_modules/cldr-data/main/es-419/currencies.json",
		859
	],
	"./es-AR/currencies.json": [
		"./node_modules/cldr-data/main/es-AR/currencies.json",
		864
	],
	"./es-BO/currencies.json": [
		"./node_modules/cldr-data/main/es-BO/currencies.json",
		869
	],
	"./es-BR/currencies.json": [
		"./node_modules/cldr-data/main/es-BR/currencies.json",
		874
	],
	"./es-BZ/currencies.json": [
		"./node_modules/cldr-data/main/es-BZ/currencies.json",
		879
	],
	"./es-CL/currencies.json": [
		"./node_modules/cldr-data/main/es-CL/currencies.json",
		884
	],
	"./es-CO/currencies.json": [
		"./node_modules/cldr-data/main/es-CO/currencies.json",
		889
	],
	"./es-CR/currencies.json": [
		"./node_modules/cldr-data/main/es-CR/currencies.json",
		894
	],
	"./es-CU/currencies.json": [
		"./node_modules/cldr-data/main/es-CU/currencies.json",
		899
	],
	"./es-DO/currencies.json": [
		"./node_modules/cldr-data/main/es-DO/currencies.json",
		904
	],
	"./es-EA/currencies.json": [
		"./node_modules/cldr-data/main/es-EA/currencies.json",
		909
	],
	"./es-EC/currencies.json": [
		"./node_modules/cldr-data/main/es-EC/currencies.json",
		914
	],
	"./es-GQ/currencies.json": [
		"./node_modules/cldr-data/main/es-GQ/currencies.json",
		919
	],
	"./es-GT/currencies.json": [
		"./node_modules/cldr-data/main/es-GT/currencies.json",
		924
	],
	"./es-HN/currencies.json": [
		"./node_modules/cldr-data/main/es-HN/currencies.json",
		929
	],
	"./es-IC/currencies.json": [
		"./node_modules/cldr-data/main/es-IC/currencies.json",
		934
	],
	"./es-MX/currencies.json": [
		"./node_modules/cldr-data/main/es-MX/currencies.json",
		939
	],
	"./es-NI/currencies.json": [
		"./node_modules/cldr-data/main/es-NI/currencies.json",
		944
	],
	"./es-PA/currencies.json": [
		"./node_modules/cldr-data/main/es-PA/currencies.json",
		949
	],
	"./es-PE/currencies.json": [
		"./node_modules/cldr-data/main/es-PE/currencies.json",
		954
	],
	"./es-PH/currencies.json": [
		"./node_modules/cldr-data/main/es-PH/currencies.json",
		959
	],
	"./es-PR/currencies.json": [
		"./node_modules/cldr-data/main/es-PR/currencies.json",
		964
	],
	"./es-PY/currencies.json": [
		"./node_modules/cldr-data/main/es-PY/currencies.json",
		969
	],
	"./es-SV/currencies.json": [
		"./node_modules/cldr-data/main/es-SV/currencies.json",
		974
	],
	"./es-US/currencies.json": [
		"./node_modules/cldr-data/main/es-US/currencies.json",
		979
	],
	"./es-UY/currencies.json": [
		"./node_modules/cldr-data/main/es-UY/currencies.json",
		984
	],
	"./es-VE/currencies.json": [
		"./node_modules/cldr-data/main/es-VE/currencies.json",
		989
	],
	"./es/currencies.json": [
		"./node_modules/cldr-data/main/es/currencies.json",
		994
	],
	"./et/currencies.json": [
		"./node_modules/cldr-data/main/et/currencies.json",
		999
	],
	"./eu/currencies.json": [
		"./node_modules/cldr-data/main/eu/currencies.json",
		1004
	],
	"./fa-AF/currencies.json": [
		"./node_modules/cldr-data/main/fa-AF/currencies.json",
		1009
	],
	"./fa/currencies.json": [
		"./node_modules/cldr-data/main/fa/currencies.json",
		1014
	],
	"./fi/currencies.json": [
		"./node_modules/cldr-data/main/fi/currencies.json",
		1019
	],
	"./fil/currencies.json": [
		"./node_modules/cldr-data/main/fil/currencies.json",
		1024
	],
	"./fr-BE/currencies.json": [
		"./node_modules/cldr-data/main/fr-BE/currencies.json",
		1029
	],
	"./fr-BF/currencies.json": [
		"./node_modules/cldr-data/main/fr-BF/currencies.json",
		1034
	],
	"./fr-BI/currencies.json": [
		"./node_modules/cldr-data/main/fr-BI/currencies.json",
		1039
	],
	"./fr-BJ/currencies.json": [
		"./node_modules/cldr-data/main/fr-BJ/currencies.json",
		1044
	],
	"./fr-BL/currencies.json": [
		"./node_modules/cldr-data/main/fr-BL/currencies.json",
		1049
	],
	"./fr-CA/currencies.json": [
		"./node_modules/cldr-data/main/fr-CA/currencies.json",
		1054
	],
	"./fr-CD/currencies.json": [
		"./node_modules/cldr-data/main/fr-CD/currencies.json",
		1059
	],
	"./fr-CF/currencies.json": [
		"./node_modules/cldr-data/main/fr-CF/currencies.json",
		1064
	],
	"./fr-CG/currencies.json": [
		"./node_modules/cldr-data/main/fr-CG/currencies.json",
		1069
	],
	"./fr-CH/currencies.json": [
		"./node_modules/cldr-data/main/fr-CH/currencies.json",
		1074
	],
	"./fr-CI/currencies.json": [
		"./node_modules/cldr-data/main/fr-CI/currencies.json",
		1079
	],
	"./fr-CM/currencies.json": [
		"./node_modules/cldr-data/main/fr-CM/currencies.json",
		1084
	],
	"./fr-DJ/currencies.json": [
		"./node_modules/cldr-data/main/fr-DJ/currencies.json",
		1089
	],
	"./fr-DZ/currencies.json": [
		"./node_modules/cldr-data/main/fr-DZ/currencies.json",
		1094
	],
	"./fr-GA/currencies.json": [
		"./node_modules/cldr-data/main/fr-GA/currencies.json",
		1099
	],
	"./fr-GF/currencies.json": [
		"./node_modules/cldr-data/main/fr-GF/currencies.json",
		1104
	],
	"./fr-GN/currencies.json": [
		"./node_modules/cldr-data/main/fr-GN/currencies.json",
		1109
	],
	"./fr-GP/currencies.json": [
		"./node_modules/cldr-data/main/fr-GP/currencies.json",
		1114
	],
	"./fr-GQ/currencies.json": [
		"./node_modules/cldr-data/main/fr-GQ/currencies.json",
		1119
	],
	"./fr-HT/currencies.json": [
		"./node_modules/cldr-data/main/fr-HT/currencies.json",
		1124
	],
	"./fr-KM/currencies.json": [
		"./node_modules/cldr-data/main/fr-KM/currencies.json",
		1129
	],
	"./fr-LU/currencies.json": [
		"./node_modules/cldr-data/main/fr-LU/currencies.json",
		1134
	],
	"./fr-MA/currencies.json": [
		"./node_modules/cldr-data/main/fr-MA/currencies.json",
		1139
	],
	"./fr-MC/currencies.json": [
		"./node_modules/cldr-data/main/fr-MC/currencies.json",
		1144
	],
	"./fr-MF/currencies.json": [
		"./node_modules/cldr-data/main/fr-MF/currencies.json",
		1149
	],
	"./fr-MG/currencies.json": [
		"./node_modules/cldr-data/main/fr-MG/currencies.json",
		1154
	],
	"./fr-ML/currencies.json": [
		"./node_modules/cldr-data/main/fr-ML/currencies.json",
		1159
	],
	"./fr-MQ/currencies.json": [
		"./node_modules/cldr-data/main/fr-MQ/currencies.json",
		1164
	],
	"./fr-MR/currencies.json": [
		"./node_modules/cldr-data/main/fr-MR/currencies.json",
		1169
	],
	"./fr-MU/currencies.json": [
		"./node_modules/cldr-data/main/fr-MU/currencies.json",
		1174
	],
	"./fr-NC/currencies.json": [
		"./node_modules/cldr-data/main/fr-NC/currencies.json",
		1179
	],
	"./fr-NE/currencies.json": [
		"./node_modules/cldr-data/main/fr-NE/currencies.json",
		1184
	],
	"./fr-PF/currencies.json": [
		"./node_modules/cldr-data/main/fr-PF/currencies.json",
		1189
	],
	"./fr-PM/currencies.json": [
		"./node_modules/cldr-data/main/fr-PM/currencies.json",
		1194
	],
	"./fr-RE/currencies.json": [
		"./node_modules/cldr-data/main/fr-RE/currencies.json",
		1199
	],
	"./fr-RW/currencies.json": [
		"./node_modules/cldr-data/main/fr-RW/currencies.json",
		1204
	],
	"./fr-SC/currencies.json": [
		"./node_modules/cldr-data/main/fr-SC/currencies.json",
		1209
	],
	"./fr-SN/currencies.json": [
		"./node_modules/cldr-data/main/fr-SN/currencies.json",
		1214
	],
	"./fr-SY/currencies.json": [
		"./node_modules/cldr-data/main/fr-SY/currencies.json",
		1219
	],
	"./fr-TD/currencies.json": [
		"./node_modules/cldr-data/main/fr-TD/currencies.json",
		1224
	],
	"./fr-TG/currencies.json": [
		"./node_modules/cldr-data/main/fr-TG/currencies.json",
		1229
	],
	"./fr-TN/currencies.json": [
		"./node_modules/cldr-data/main/fr-TN/currencies.json",
		1234
	],
	"./fr-VU/currencies.json": [
		"./node_modules/cldr-data/main/fr-VU/currencies.json",
		1239
	],
	"./fr-WF/currencies.json": [
		"./node_modules/cldr-data/main/fr-WF/currencies.json",
		1244
	],
	"./fr-YT/currencies.json": [
		"./node_modules/cldr-data/main/fr-YT/currencies.json",
		1249
	],
	"./fr/currencies.json": [
		"./node_modules/cldr-data/main/fr/currencies.json",
		1254
	],
	"./ga-GB/currencies.json": [
		"./node_modules/cldr-data/main/ga-GB/currencies.json",
		1259
	],
	"./ga/currencies.json": [
		"./node_modules/cldr-data/main/ga/currencies.json",
		1264
	],
	"./gl/currencies.json": [
		"./node_modules/cldr-data/main/gl/currencies.json",
		1269
	],
	"./gu/currencies.json": [
		"./node_modules/cldr-data/main/gu/currencies.json",
		1274
	],
	"./he/currencies.json": [
		"./node_modules/cldr-data/main/he/currencies.json",
		1279
	],
	"./hi/currencies.json": [
		"./node_modules/cldr-data/main/hi/currencies.json",
		1284
	],
	"./hr-BA/currencies.json": [
		"./node_modules/cldr-data/main/hr-BA/currencies.json",
		1289
	],
	"./hr/currencies.json": [
		"./node_modules/cldr-data/main/hr/currencies.json",
		1294
	],
	"./hu/currencies.json": [
		"./node_modules/cldr-data/main/hu/currencies.json",
		1299
	],
	"./hy/currencies.json": [
		"./node_modules/cldr-data/main/hy/currencies.json",
		1304
	],
	"./id/currencies.json": [
		"./node_modules/cldr-data/main/id/currencies.json",
		1309
	],
	"./is/currencies.json": [
		"./node_modules/cldr-data/main/is/currencies.json",
		1314
	],
	"./it-CH/currencies.json": [
		"./node_modules/cldr-data/main/it-CH/currencies.json",
		1319
	],
	"./it-SM/currencies.json": [
		"./node_modules/cldr-data/main/it-SM/currencies.json",
		1324
	],
	"./it-VA/currencies.json": [
		"./node_modules/cldr-data/main/it-VA/currencies.json",
		1329
	],
	"./it/currencies.json": [
		"./node_modules/cldr-data/main/it/currencies.json",
		1334
	],
	"./ja/currencies.json": [
		"./node_modules/cldr-data/main/ja/currencies.json",
		1339
	],
	"./jv/currencies.json": [
		"./node_modules/cldr-data/main/jv/currencies.json",
		1344
	],
	"./ka/currencies.json": [
		"./node_modules/cldr-data/main/ka/currencies.json",
		1349
	],
	"./kk/currencies.json": [
		"./node_modules/cldr-data/main/kk/currencies.json",
		1354
	],
	"./km/currencies.json": [
		"./node_modules/cldr-data/main/km/currencies.json",
		1359
	],
	"./kn/currencies.json": [
		"./node_modules/cldr-data/main/kn/currencies.json",
		1364
	],
	"./ko-KP/currencies.json": [
		"./node_modules/cldr-data/main/ko-KP/currencies.json",
		1369
	],
	"./ko/currencies.json": [
		"./node_modules/cldr-data/main/ko/currencies.json",
		1374
	],
	"./ky/currencies.json": [
		"./node_modules/cldr-data/main/ky/currencies.json",
		1379
	],
	"./lo/currencies.json": [
		"./node_modules/cldr-data/main/lo/currencies.json",
		1384
	],
	"./lt/currencies.json": [
		"./node_modules/cldr-data/main/lt/currencies.json",
		1389
	],
	"./lv/currencies.json": [
		"./node_modules/cldr-data/main/lv/currencies.json",
		1394
	],
	"./mk/currencies.json": [
		"./node_modules/cldr-data/main/mk/currencies.json",
		1399
	],
	"./ml/currencies.json": [
		"./node_modules/cldr-data/main/ml/currencies.json",
		1404
	],
	"./mn/currencies.json": [
		"./node_modules/cldr-data/main/mn/currencies.json",
		1409
	],
	"./mr/currencies.json": [
		"./node_modules/cldr-data/main/mr/currencies.json",
		1414
	],
	"./ms-BN/currencies.json": [
		"./node_modules/cldr-data/main/ms-BN/currencies.json",
		1419
	],
	"./ms-SG/currencies.json": [
		"./node_modules/cldr-data/main/ms-SG/currencies.json",
		1424
	],
	"./ms/currencies.json": [
		"./node_modules/cldr-data/main/ms/currencies.json",
		1429
	],
	"./my/currencies.json": [
		"./node_modules/cldr-data/main/my/currencies.json",
		1434
	],
	"./nb-SJ/currencies.json": [
		"./node_modules/cldr-data/main/nb-SJ/currencies.json",
		1439
	],
	"./nb/currencies.json": [
		"./node_modules/cldr-data/main/nb/currencies.json",
		1444
	],
	"./ne-IN/currencies.json": [
		"./node_modules/cldr-data/main/ne-IN/currencies.json",
		1449
	],
	"./ne/currencies.json": [
		"./node_modules/cldr-data/main/ne/currencies.json",
		1454
	],
	"./nl-AW/currencies.json": [
		"./node_modules/cldr-data/main/nl-AW/currencies.json",
		1459
	],
	"./nl-BE/currencies.json": [
		"./node_modules/cldr-data/main/nl-BE/currencies.json",
		1464
	],
	"./nl-BQ/currencies.json": [
		"./node_modules/cldr-data/main/nl-BQ/currencies.json",
		1469
	],
	"./nl-CW/currencies.json": [
		"./node_modules/cldr-data/main/nl-CW/currencies.json",
		1474
	],
	"./nl-SR/currencies.json": [
		"./node_modules/cldr-data/main/nl-SR/currencies.json",
		1479
	],
	"./nl-SX/currencies.json": [
		"./node_modules/cldr-data/main/nl-SX/currencies.json",
		1484
	],
	"./nl/currencies.json": [
		"./node_modules/cldr-data/main/nl/currencies.json",
		1489
	],
	"./or/currencies.json": [
		"./node_modules/cldr-data/main/or/currencies.json",
		1494
	],
	"./pa-Guru/currencies.json": [
		"./node_modules/cldr-data/main/pa-Guru/currencies.json",
		1499
	],
	"./pa/currencies.json": [
		"./node_modules/cldr-data/main/pa/currencies.json",
		1504
	],
	"./pl/currencies.json": [
		"./node_modules/cldr-data/main/pl/currencies.json",
		1509
	],
	"./ps-PK/currencies.json": [
		"./node_modules/cldr-data/main/ps-PK/currencies.json",
		1514
	],
	"./ps/currencies.json": [
		"./node_modules/cldr-data/main/ps/currencies.json",
		1519
	],
	"./pt-AO/currencies.json": [
		"./node_modules/cldr-data/main/pt-AO/currencies.json",
		1524
	],
	"./pt-CH/currencies.json": [
		"./node_modules/cldr-data/main/pt-CH/currencies.json",
		1529
	],
	"./pt-CV/currencies.json": [
		"./node_modules/cldr-data/main/pt-CV/currencies.json",
		1534
	],
	"./pt-GQ/currencies.json": [
		"./node_modules/cldr-data/main/pt-GQ/currencies.json",
		1539
	],
	"./pt-GW/currencies.json": [
		"./node_modules/cldr-data/main/pt-GW/currencies.json",
		1544
	],
	"./pt-LU/currencies.json": [
		"./node_modules/cldr-data/main/pt-LU/currencies.json",
		1549
	],
	"./pt-MO/currencies.json": [
		"./node_modules/cldr-data/main/pt-MO/currencies.json",
		1554
	],
	"./pt-MZ/currencies.json": [
		"./node_modules/cldr-data/main/pt-MZ/currencies.json",
		1559
	],
	"./pt-PT/currencies.json": [
		"./node_modules/cldr-data/main/pt-PT/currencies.json",
		1564
	],
	"./pt-ST/currencies.json": [
		"./node_modules/cldr-data/main/pt-ST/currencies.json",
		1569
	],
	"./pt-TL/currencies.json": [
		"./node_modules/cldr-data/main/pt-TL/currencies.json",
		1574
	],
	"./pt/currencies.json": [
		"./node_modules/cldr-data/main/pt/currencies.json",
		1579
	],
	"./ro-MD/currencies.json": [
		"./node_modules/cldr-data/main/ro-MD/currencies.json",
		1584
	],
	"./ro/currencies.json": [
		"./node_modules/cldr-data/main/ro/currencies.json",
		1589
	],
	"./root/currencies.json": [
		"./node_modules/cldr-data/main/root/currencies.json",
		1594
	],
	"./ru-BY/currencies.json": [
		"./node_modules/cldr-data/main/ru-BY/currencies.json",
		1599
	],
	"./ru-KG/currencies.json": [
		"./node_modules/cldr-data/main/ru-KG/currencies.json",
		1604
	],
	"./ru-KZ/currencies.json": [
		"./node_modules/cldr-data/main/ru-KZ/currencies.json",
		1609
	],
	"./ru-MD/currencies.json": [
		"./node_modules/cldr-data/main/ru-MD/currencies.json",
		1614
	],
	"./ru-UA/currencies.json": [
		"./node_modules/cldr-data/main/ru-UA/currencies.json",
		1619
	],
	"./ru/currencies.json": [
		"./node_modules/cldr-data/main/ru/currencies.json",
		1624
	],
	"./sd/currencies.json": [
		"./node_modules/cldr-data/main/sd/currencies.json",
		1629
	],
	"./si/currencies.json": [
		"./node_modules/cldr-data/main/si/currencies.json",
		1634
	],
	"./sk/currencies.json": [
		"./node_modules/cldr-data/main/sk/currencies.json",
		1639
	],
	"./sl/currencies.json": [
		"./node_modules/cldr-data/main/sl/currencies.json",
		1644
	],
	"./so-DJ/currencies.json": [
		"./node_modules/cldr-data/main/so-DJ/currencies.json",
		1649
	],
	"./so-ET/currencies.json": [
		"./node_modules/cldr-data/main/so-ET/currencies.json",
		1654
	],
	"./so-KE/currencies.json": [
		"./node_modules/cldr-data/main/so-KE/currencies.json",
		1659
	],
	"./so/currencies.json": [
		"./node_modules/cldr-data/main/so/currencies.json",
		1664
	],
	"./sq-MK/currencies.json": [
		"./node_modules/cldr-data/main/sq-MK/currencies.json",
		1669
	],
	"./sq-XK/currencies.json": [
		"./node_modules/cldr-data/main/sq-XK/currencies.json",
		1674
	],
	"./sq/currencies.json": [
		"./node_modules/cldr-data/main/sq/currencies.json",
		1679
	],
	"./sr-Cyrl-BA/currencies.json": [
		"./node_modules/cldr-data/main/sr-Cyrl-BA/currencies.json",
		1684
	],
	"./sr-Cyrl-ME/currencies.json": [
		"./node_modules/cldr-data/main/sr-Cyrl-ME/currencies.json",
		1689
	],
	"./sr-Cyrl-XK/currencies.json": [
		"./node_modules/cldr-data/main/sr-Cyrl-XK/currencies.json",
		1694
	],
	"./sr-Cyrl/currencies.json": [
		"./node_modules/cldr-data/main/sr-Cyrl/currencies.json",
		1699
	],
	"./sr-Latn-BA/currencies.json": [
		"./node_modules/cldr-data/main/sr-Latn-BA/currencies.json",
		1704
	],
	"./sr-Latn-ME/currencies.json": [
		"./node_modules/cldr-data/main/sr-Latn-ME/currencies.json",
		1709
	],
	"./sr-Latn-XK/currencies.json": [
		"./node_modules/cldr-data/main/sr-Latn-XK/currencies.json",
		1714
	],
	"./sr-Latn/currencies.json": [
		"./node_modules/cldr-data/main/sr-Latn/currencies.json",
		1719
	],
	"./sr/currencies.json": [
		"./node_modules/cldr-data/main/sr/currencies.json",
		1724
	],
	"./sv-AX/currencies.json": [
		"./node_modules/cldr-data/main/sv-AX/currencies.json",
		1729
	],
	"./sv-FI/currencies.json": [
		"./node_modules/cldr-data/main/sv-FI/currencies.json",
		1734
	],
	"./sv/currencies.json": [
		"./node_modules/cldr-data/main/sv/currencies.json",
		1739
	],
	"./sw-CD/currencies.json": [
		"./node_modules/cldr-data/main/sw-CD/currencies.json",
		1744
	],
	"./sw-KE/currencies.json": [
		"./node_modules/cldr-data/main/sw-KE/currencies.json",
		1749
	],
	"./sw-UG/currencies.json": [
		"./node_modules/cldr-data/main/sw-UG/currencies.json",
		1754
	],
	"./sw/currencies.json": [
		"./node_modules/cldr-data/main/sw/currencies.json",
		1759
	],
	"./ta-LK/currencies.json": [
		"./node_modules/cldr-data/main/ta-LK/currencies.json",
		1764
	],
	"./ta-MY/currencies.json": [
		"./node_modules/cldr-data/main/ta-MY/currencies.json",
		1769
	],
	"./ta-SG/currencies.json": [
		"./node_modules/cldr-data/main/ta-SG/currencies.json",
		1774
	],
	"./ta/currencies.json": [
		"./node_modules/cldr-data/main/ta/currencies.json",
		1779
	],
	"./te/currencies.json": [
		"./node_modules/cldr-data/main/te/currencies.json",
		1784
	],
	"./th/currencies.json": [
		"./node_modules/cldr-data/main/th/currencies.json",
		1789
	],
	"./tk/currencies.json": [
		"./node_modules/cldr-data/main/tk/currencies.json",
		1794
	],
	"./tr-CY/currencies.json": [
		"./node_modules/cldr-data/main/tr-CY/currencies.json",
		1799
	],
	"./tr/currencies.json": [
		"./node_modules/cldr-data/main/tr/currencies.json",
		1804
	],
	"./uk/currencies.json": [
		"./node_modules/cldr-data/main/uk/currencies.json",
		1809
	],
	"./ur-IN/currencies.json": [
		"./node_modules/cldr-data/main/ur-IN/currencies.json",
		1814
	],
	"./ur/currencies.json": [
		"./node_modules/cldr-data/main/ur/currencies.json",
		1819
	],
	"./uz-Latn/currencies.json": [
		"./node_modules/cldr-data/main/uz-Latn/currencies.json",
		1824
	],
	"./uz/currencies.json": [
		"./node_modules/cldr-data/main/uz/currencies.json",
		1829
	],
	"./vi/currencies.json": [
		"./node_modules/cldr-data/main/vi/currencies.json",
		1834
	],
	"./yue-Hant/currencies.json": [
		"./node_modules/cldr-data/main/yue-Hant/currencies.json",
		1839
	],
	"./yue/currencies.json": [
		"./node_modules/cldr-data/main/yue/currencies.json",
		1844
	],
	"./zh-Hans-HK/currencies.json": [
		"./node_modules/cldr-data/main/zh-Hans-HK/currencies.json",
		1849
	],
	"./zh-Hans-MO/currencies.json": [
		"./node_modules/cldr-data/main/zh-Hans-MO/currencies.json",
		1854
	],
	"./zh-Hans-SG/currencies.json": [
		"./node_modules/cldr-data/main/zh-Hans-SG/currencies.json",
		1859
	],
	"./zh-Hans/currencies.json": [
		"./node_modules/cldr-data/main/zh-Hans/currencies.json",
		1864
	],
	"./zh-Hant-HK/currencies.json": [
		"./node_modules/cldr-data/main/zh-Hant-HK/currencies.json",
		1869
	],
	"./zh-Hant-MO/currencies.json": [
		"./node_modules/cldr-data/main/zh-Hant-MO/currencies.json",
		1874
	],
	"./zh-Hant/currencies.json": [
		"./node_modules/cldr-data/main/zh-Hant/currencies.json",
		1879
	],
	"./zh/currencies.json": [
		"./node_modules/cldr-data/main/zh/currencies.json",
		1884
	],
	"./zu/currencies.json": [
		"./node_modules/cldr-data/main/zu/currencies.json",
		1889
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./node_modules/cldr-data/main lazy recursive ^\\.\\/.*\\/currencies\\.json$";
module.exports = webpackAsyncContext;